import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";

import { LoginRoute } from "../../Components/LoginRoute";

const loginSearchSchema = z.object({
	redirect: z.string().optional(),
	prefillUsername: z.string().optional(),
});

export const Route = createFileRoute("/_accountLayout/login")({
	component: RouteComponent,
	validateSearch: loginSearchSchema,
});

function RouteComponent() {
	const search = useSearch({ from: "/_accountLayout/login" });

	return <LoginRoute prefillUsername={search.prefillUsername} />;
}
